import React from "react"
import { accesDirectItem, editButton } from "../acces-direct.module.scss"
import AccesDirectItem from "../AccesDirectItem/acces-direct-item"
import PropTypes from "prop-types"
import { AccesDirectItemContainer } from "./render-acces-direct-styled"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

const RenderAccesDirect = ({ accesDirectData }) => {
  const accesDirects = accesDirectData.allDirectLinkEntityDirectLinkEntity.edges
  return (
    <>
      {accesDirects.map(({ node }) => (
        <AccesDirectItemContainer
          key={node.drupal_id}
          className={accesDirectItem}
          role={"listitem"}
        >
          <EditButton
            link={
              "/admin/structure/direct_link_entity/" +
              node.drupal_internal__id +
              "/edit"
            }
            addedClass={editButton}
          />
          <AccesDirectItem accesDirect={node} />
        </AccesDirectItemContainer>
      ))}
    </>
  )
}

RenderAccesDirect.propTypes = {
  accesDirectData: PropTypes.object.isRequired,
}

export default RenderAccesDirect
